<template>
  <v-col
    cols="12"
    md="3"
    :order="$vuetify.breakpoint.mdAndUp ? '' : 'first'"
    class="d-flex flex-column"
  >
    <p class="primary--text text-body-2 text-sm-body-1 mb-0 mb-md-5">
      <strong>Atenção:</strong>
      Este é um ambiente dedicado à troca de mensagens entre você e o vendedor.
      A Monetizze não realizará a mediação das conversas e, não terá acesso às
      mensagens trocadas entre vocês, não podendo ser, em qualquer hipótese,
      responsabilizada pelo conteúdo das mensagens trocadas.
    </p>

    <div
      class="d-flex align-start flex-column flex-lg-row order-first order-md-last"
    >
      <v-card v-if="scrImage && $vuetify.breakpoint.mdAndUp">
        <v-img
          :src="scrImage"
          height="122"
          width="122"
        />
      </v-card>
      <div class="pl-lg-4 mt-md-3 mt-lg-0">
        <p class="body-2 primary--text">
          <strong>{{ dadosTransacao.parent_product_name }}</strong>
        </p>

        <p class="align-center body-2 d-flex">
          <v-img
            v-if="dadosTransacao.is_pix"
            :src="require(`@/assets/img/logo-pix.png`)"
            alt="Logo Pix"
            class="flex-grow-0 mr-2"
            height="17"
            width="48"
          />

          <v-img
            v-else-if="dadosTransacao.is_paypal"
            :src="require(`@/assets/img/logo-paypal.png`)"
            alt="Logo Paypal"
            class="flex-grow-0 mr-2"
            height="20"
            width="64"
          />

          <v-icon
            v-else-if="isCartaoOuBoleto"
            class="pr-2"
            color="primary"
            small
          >
            {{ iconePagamento }}
          </v-icon>

          {{ this.dadosTransacao.total | moeda(this.dadosTransacao.currency_symbol) }}
        </p>

        <p
          :class="status.textColor"
          class="align-center body-2 d-flex"
        >
          <v-icon
            :color="status.color"
            class="pr-1"
          >
            {{ status.icone }}
          </v-icon>
          {{ status.text }}
        </p>
      </div>
    </div>
  </v-col>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ChatInfo',

  computed: {
    ...mapState(['dadosTransacao']),

    iconePagamento() {
      return this.dadosTransacao.is_boleto || this.dadosTransacao.is_boleto_in_installments
        ? 'fas fa-barcode'
        : 'far fa-credit-card';
    },

    isCartaoOuBoleto() {
      if (this.dadosTransacao.is_credit_card || this.dadosTransacao.is_debit_card
        || this.dadosTransacao.is_boleto
        || this.dadosTransacao.is_boleto_in_installments) return true;

      return false;
    },

    scrImage() {
      const { parent_product_id: produtoPrincipalId } = this.dadosTransacao;
      const { products: produto = [] } = this.dadosTransacao;
      const produtoPrincipal = produto.filter(value => value.id === produtoPrincipalId);
      if (produto.length > 0) return produtoPrincipal[0].image_url;

      return '';
    },

    status() {
      const texto = '--text';
      const { refund_request_status_flag: flagReembolso } = this.dadosTransacao;
      const statusReembolso = this.dadosTransacao.refund_request_status_slug === 'reembolso-cancelado';

      if (flagReembolso && !statusReembolso) {
        return {
          color: flagReembolso,
          icone: this.retornaIcone(flagReembolso),
          text: this.dadosTransacao.refund_request_status,
          textColor: flagReembolso + texto,
        };
      }
      if (this.dadosTransacao.membership_status_flag) {
        return {
          color: this.dadosTransacao.membership_status_flag,
          icone: this.retornaIcone(this.dadosTransacao.membership_status_flag),
          text: this.dadosTransacao.membership_status,
          textColor: this.dadosTransacao.membership_status_flag + texto,
        };
      }

      return {
        color: this.dadosTransacao.status_flag,
        icone: this.retornaIcone(this.dadosTransacao.status_flag),
        text: this.dadosTransacao.status,
        textColor: this.dadosTransacao.status_flag + texto,
      };
    },
  },

  methods: {
    retornaIcone(status) {
      if (status === 'warning') return 'error';
      if (status === 'success') return 'check_circle';
      return 'cancel';
    },
  },
};
</script>
